import axios from 'axios';

declare let booking_object: any;

export default class getInitDates{

    /**
     * Change date
     * @param book_calendar 
     * @param el_rooms 
     * @param el_games 
     * @param el_time_slot 
     */
    change(
        book_calendar: any,
        el_rooms: string,
        el_games: string,
        el_time_slot: string,
    ){
        
        if(typeof book_calendar.pickerElement !== 'undefined'){
            
            // Element room
            const elRoom = document.querySelector(el_rooms) as HTMLSelectElement | null;
            
            // Element game
            const elGame = document.querySelector(el_games) as HTMLSelectElement | null;
            
            // Element time slot
            const elTimeSlot: any = document.querySelector(el_time_slot);
            const control_timeslot = elTimeSlot.tomselect;
        
            book_calendar.pickerElement.addEventListener('click', (ev) => {
    
                const element = ev.target as Element;
    
                if(!element?.matches('.day')){
                    
                    return;
                    
                }

                // Get games player
                let get_games = document.querySelector(el_games) as any;
                let get_games_control = get_games?.tomselect;
                get_games_control.setValue(get_games_control.getValue());

                // Get date
                const val_date = book_calendar.getDate('y/mm/dd');

                if(typeof val_date !== 'undefined' && elRoom?.value.length !== 0 && elGame?.value.length !== 0){
                    
                    control_timeslot.enable();
                    control_timeslot.clear();
                    control_timeslot.clearOptions();

                    // Post data
                    const post_data = {
                        'room_id': (elRoom !== null) ? elRoom.value : '',
                        'game_id': (elGame !== null) ? elGame.value : '',
                        'date': (typeof val_date !== 'undefined') ? val_date : '',
                    };
                
                    // Query string
                    const queryString = new URLSearchParams(post_data).toString();
            
                    // Call ajax
                    axios.post(booking_object.rest_urls.get_room, queryString)
                    .then(function (response: any) {
                        
                        const data = response.data.data;

                        const isObjectEmpty = (objectName) => {
                            return Object.keys(objectName).length === 0
                        }

                        if(isObjectEmpty(data) === false){
                            
                            control_timeslot.enable();

                            control_timeslot.addOptions(response.data, false);
                            control_timeslot.setValue([data[0].slot_time]);

                        }else{

                            control_timeslot.addOption({
                                slot_time: '',
                                slot_start_time: null,
                                slot_end_time: null,
                                no_data: 'Nessuno slot disponibile'
                            });
                            control_timeslot.setValue('');
                            control_timeslot.disable();

                        }
            
                    })
                    .catch(function (error: any){
            
                        console.log(error);
            
                    });

                }else{

                    control_timeslot.clear();
                    control_timeslot.clearOptions();
                    control_timeslot.disable();
                    return;

                }
                
            });
    
        }
        
    }

}